//WE.Flow.Html.Contracts.Manifests.CommandManifest

export class CommandManifest {
    scriptPath: string = "";
}
